<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Rebook Reservation</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="loadingBooking">
    <h3 class="text-muted">Loading...</h3>
  </div>

  <div class="modal-body" *ngIf="!loadingBooking && booking">

    <p class="mb-2">
      <b>{{ booking.event_type_name }}</b>
      <ng-container *ngFor="let eventPart of booking.event_parts">
        <br>
        <b>
          {{ eventPart.event_date_str }},
          {{ eventPart.event_start_time }} -
          {{ eventPart.event_end_time }}
        </b>
      </ng-container>
    </p>

    <p class="mb-0">Participants:</p>
    <ul>
      <li *ngFor="let res of booking.active_reservations">
        <b>{{ res.first_name }} {{ res.last_name }}</b>
      </li>
    </ul>

    <hr>

    <p *ngIf="loadingSelectedEvent">Loading...</p>

    <ng-container *ngIf="!loadingSelectedEvent && !selectedEvent">

      <p>Select a Time Slot</p>

      <div class="mb-2">
        <app-date-picker [id]="'selectedDate'"
                         [(content)]="selectedDate"
                         (contentChange)="loadEventsForDate()"
                         [small]="true"></app-date-picker>
      </div>

      <div class="rounded-table-wrapper rounded-table-tight">
        <table class="table table-sm">
          <thead>
          <tr>
            <th scope="col">Time</th>
            <th scope="col">R/C</th>
            <th scope="col">Location</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngIf="!loadingEventsForDate">
            <tr *ngFor="let scheduledEvent of scheduledEventsForDate">
              <td>
                <span style="white-space: nowrap">
                  {{ timeStringFromISO8601(scheduledEvent.start_datetime, scheduledEvent.time_zone) }} -
                  {{ timeStringFromISO8601(scheduledEvent.end_datetime, scheduledEvent.time_zone) }}
                </span>
                <span *ngIf="scheduledEvent.is_cancelled">&ndash; <b>Cancelled</b></span>
                <span style="white-space: nowrap" *ngIf="scheduledEvent.event_part_count > 1">
                  (Part {{ scheduledEvent.event_part_number }} of {{ scheduledEvent.event_part_count }})
                </span>
                <ng-container *ngIf="scheduledEvent.schedule_name">
                  <br>
                  <i>{{ scheduledEvent.schedule_name }}</i>
                </ng-container>
                <ng-container *ngIf="scheduledEvent.customer_facing_name && (scheduledEvent.customer_facing_name !== scheduledEvent.schedule_name)">
                  <br>
                  <i>{{ scheduledEvent.customer_facing_name }}</i>
                </ng-container>
              </td>
              <td>
                <span placement="bottom" style="white-space: nowrap"
                      [ngbTooltip]="eventFullDueToSecondaryCapacity(scheduledEvent) ? 'Facility capacity or booking limit reached for this time slot.' : ''">
                  {{ scheduledEvent.reservation_count }} / {{ scheduledEvent.capacity }}
                  <span *ngIf="eventFullDueToSecondaryCapacity(scheduledEvent)">*</span>
                </span>
              </td>
              <td>
                {{ scheduledEvent.location_name }}
              </td>
              <td class="table-sm-button-cell">
                <button *ngIf="scheduledEvent.capacity < booking.active_reservations.length"
                        class="btn btn-sm btn-outline-primary table-sm-button float-right disabled"
                        disabled>
                  No Capacity
                </button>
                <button *ngIf="scheduledEvent.capacity >= booking.active_reservations.length"
                        class="btn btn-sm btn-outline-primary table-sm-button float-right"
                        (click)="loadSelectedEvent(scheduledEvent.event_id)">
                  Select
                </button>
              </td>
            </tr>
            <tr *ngIf="scheduledEventsForDate.length === 0">
              <td colspan="99">No time slots for the selected date</td>
            </tr>
          </ng-container>
          <tr *ngIf="loadingEventsForDate">
            <td colspan="99">Loading...</td>
          </tr>
          </tbody>
        </table>
      </div>

    </ng-container>

    <ng-container *ngIf="!loadingSelectedEvent && selectedEvent">
      <button class="btn btn-sm btn-link float-right" style="margin-top: -6px"
              (click)="selectedEvent = null">
        Clear Selection
      </button>

      <ng-container *ngIf="selectedEvent.event_parts.length === 1">
        <p>
          Selected Event:
          <b>
            {{ selectedEvent.event_parts[0].start_local_date }},
            {{ selectedEvent.event_parts[0].start_local_time }} -
            {{ selectedEvent.event_parts[0].end_local_time }}
          </b>
        </p>
      </ng-container>
      <ng-container *ngIf="selectedEvent.event_parts.length > 1">
        <p class="mb-1">Selected multi-part event:</p>
        <ul>
          <li *ngFor="let eventPart of selectedEvent.event_parts">
            <b>
              {{ eventPart.start_local_date }},
              {{ eventPart.start_local_time }} -
              {{ eventPart.end_local_time }}
            </b>
          </li>
        </ul>
      </ng-container>
    </ng-container>

    <hr>

    <p class="mb-1">An email will be sent to each participant notifying them of the rebooking.</p>
    <p>You may optionally provide text below to include at the bottom of the email.</p>

    <div class="form-group">
      <label>Rebooking Email Text (Optional)</label>
      <app-markdown-editor [(content)]="rebookingEmailText"
                           [id]="'rebookingEmailTextArea'"
                           [shortEditor]="true">
      </app-markdown-editor>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Go Back
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="!selectedEvent">
      Select a Time Slot Above
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!isLoading() && selectedEvent"
            (click)="handleSubmit()">
      Confirm
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="isLoading() && selectedEvent">
      Loading...
    </button>
  </div>

</ng-container>
